module.exports = __webpack_public_path__ + "img/photo-0004.b2325031.jpg";